import * as React from "react";
import { type FC } from "react";

import { AddressLevel } from "../../../../FiasInput/Types/FiasTypes";
import { AddressRow } from "../AddressRow";
import { Control } from "../controlsPaths";

interface StreetProps {
    fullSizeAbbreviation: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const addressLevel = AddressLevel.Street;
const controlType = Control.StreetType;
const controlName = Control.StreetName;

export const Street: FC<StreetProps> = props => (
    <AddressRow
        caption={"Элемент улично-дорожной сети"}
        typePlaceholder={"Тип"}
        namePlaceholder={"Наименование"}
        typeTid={"StreetType"}
        nameTid={"StreetName"}
        fullSizeAbbreviation={props.fullSizeAbbreviation}
        controlType={controlType}
        level={addressLevel}
        type={props.getValue(controlType)}
        name={props.getValue(controlName)}
        onTypeChange={props.onChange(controlType)}
        onNameChange={props.onChange(controlName)}
    />
);
